/**
 * @deprecated Import from 'src/integrations/react-router/index.js' instead.
 */
export {
  run as runReactRouterInstallerAgent,
  config as REACT_ROUTER_AGENT_CONFIG,
} from '../integrations/react-router/index.js';
